import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../config/config';

const Reviews = () => {
  const renderStars = (rating) => {
    return '⭐'.repeat(rating);
  };

  return (
    <section className="reviews" id="reviews">
      <motion.p
        className="sec-label"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Client Testimonials
      </motion.p>
      <motion.h2
        className="sec-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        WHAT OUR <span>CLIENTS SAY</span>
      </motion.h2>
      <div className="reviews-grid">
        {config.reviews.map((review, idx) => (
          <motion.div
            key={review.id}
            className="review-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            whileHover={{ y: -5 }}
          >
            <div className="review-header">
              <div>
                <div className="review-name">{review.name}</div>
                <div className="review-location">{review.location}</div>
              </div>
              <div className="review-stars">{renderStars(review.rating)}</div>
            </div>
            <p className="review-text">"{review.text}"</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Reviews;
